// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","picker":"styles_picker__EZxx4","dropdown":"styles_dropdown__roNCO","container":"styles_container__rc-Cc"};